// extracted by mini-css-extract-plugin
export default {"item":"Pack_item__xxWpd","img":"Pack_img__Q-6LR"};